import React from "react";
import { string, node } from "prop-types";
import Image from "pages/_components/Image";
import { push } from "connected-react-router";
import { useDispatch } from "react-redux";
import Button from "pages/_components/Button";

function WidgetHeader({ title, action, goTo }) {
    const dispatch = useDispatch();
    const handleClick = () => {
        let link = goTo;
        if (goTo === "pendingTransactions") {
            link = "pendingTransaction/list";
        }
        if (goTo === "scheduledTransactions" || goTo === "portfolio" || goTo === "exchangeRates") {
            link = "desktop";
        }
        dispatch(push(`/${link}`));
    };
    return (
        <header className="widget-title title-grid-container">
            <h2>{title}</h2>
            <div>
                <p className="">
                    {!goTo && (
                        <>
                            {action}
                            <Image className="svg-icon icon-link ml-4" src="images/arrowRight.svg" />
                        </>
                    )}
                    {goTo && (
                        <Button className="btn-link btn-only-icon button-rigth" onClick={() => handleClick()}>
                            <Image className="svg-icon icon-link ml-4" src="images/arrowRight.svg" />
                        </Button>
                    )}
                </p>
            </div>
        </header>
    );
}

WidgetHeader.propTypes = {
    title: string.isRequired,
    action: node,
    goTo: string,
};
WidgetHeader.defaultProps = {
    action: null,
    goTo: "",
};

export default WidgetHeader;
